import React from "react";
import * as Si from "react-icons/si";
import * as Fa from "react-icons/fa6";

/**
 * Resilient platform icon. Looks up a Simple Icons (`Si*`) or Font Awesome
 * (`Fa*`) export by name; if the icon isn't available in react-icons, falls back
 * to a tracked monogram so the build never breaks. Rendered monochrome
 * (currentColor) — never recolored to gold.
 */
export const PlatformIcon = ({ name, iconName, size = 26, className = "" }) => {
  const Icon = Si[iconName] || Fa[iconName];
  if (Icon) return <Icon size={size} className={className} aria-hidden="true" />;
  const initials = (name || "?").replace(/[^A-Za-z]/g, "").slice(0, 2).toUpperCase();
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{ fontFamily: "var(--caps)", fontSize: size * 0.5, letterSpacing: ".08em" }}
    >
      {initials}
    </span>
  );
};
